/*  ========================================================================
    # Components - Project Slide Card
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import useLocalization from '../hooks/useLocalization';
import useTranslation from '../hooks/useTranslation';
import bem from '../helpers/bem';
import tailwindConfig from '../../../tailwind.config';
import LazyImage from './LazyImage';
import LazySource from './LazySource';

const ProjectSlideCard = ({ customer, projectName, excerpt, image, permalink, dataOffset }) => {
  const __ = useTranslation();

  // Icons
  const local = useLocalization();
  const iconArrowRight = `${local('svgSprite')}#arrow-small-right`;

  return (
    <a
      href={permalink}
      className={bem('c-project-slide-card')}
      title={customer}
      data-offset={dataOffset}
    >
      <LazyImage
        alt={image.alt}
        defaultUrl={image.sizes.large}
        placeholderUrl={image.sizes.placeholder}
        figureClass={bem('c-project-slide-card', 'image')}
      >
        <LazySource srcSet={image.sizes.large} mediaMin={tailwindConfig.theme.screens.lg} />
        <LazySource srcSet={image.sizes.medium_large} mediaMin={tailwindConfig.theme.screens.md} />
        <LazySource srcSet={image.sizes.medium} mediaMin={tailwindConfig.theme.screens.sm} />
      </LazyImage>
      <div className={bem('c-project-slide-card', 'content')}>
        <h3>
          <strong dangerouslySetInnerHTML={{ __html: customer }} />
          <span dangerouslySetInnerHTML={{ __html: projectName }} />
        </h3>
        {excerpt && <p dangerouslySetInnerHTML={{ __html: excerpt }} />}
        <div className={bem('c-project-slide-card', 'show-more')}>
          {__('learn-more')}
          <svg viewBox='0 0 200 200'>
            <use href={iconArrowRight}></use>
          </svg>
        </div>
      </div>
    </a>
  );
};

ProjectSlideCard.propTypes = {
  customer: PropTypes.string,
  projectName: PropTypes.string,
  excerpt: PropTypes.string,
  image: PropTypes.object,
  permalink: PropTypes.string,
  dataOffset: PropTypes.number
};

export default ProjectSlideCard;
